import React from 'react'

import { employersPaySchedules } from 'rails_routes'
import { Banner, Button } from 'slab'
import { useWindowLocation } from 'utils/windowLocation'

export const MissingScheduleForAutomationHeaderBanner: React.FC = () => {
  const { assign } = useWindowLocation()

  return (
    <Banner
      type='warning'
      title='Pay schedule details are missing'
      cta={
        <Button
          variant='secondary'
          size='small'
          onClick={() => { assign(employersPaySchedules.index()) }}
        >
          Add pay schedules
        </Button>
      }
    >
      To automate your employee payroll deductions, we need details on at least one company pay schedule from you.
      <br />
      Without one, we won't be able automate your employee deductions — instead, we'll generate monthly reports that you'll have to manually import into your payroll system.
    </Banner>
  )
}
